import { FormattedMessage } from 'react-intl';

import { HiringGoalsContent } from '@/components/pages/channels/hiring-goals-modal/hiring-goals-content';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';

interface HiringGoalModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  hireATHiringGoalUrl: string;
}

function HiringGoalModal({
  open,
  onOpenChange,
  hireATHiringGoalUrl,
}: HiringGoalModalProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="min-w-[550px]">
        <SheetHeader>
          <SheetTitle>
            <FormattedMessage defaultMessage="Hiring goals" />
          </SheetTitle>
        </SheetHeader>

        <HiringGoalsContent
          hireATHiringGoalUrl={hireATHiringGoalUrl}
          onClose={() => onOpenChange(false)}
        />

        <SheetFooter>
          <Button
            variant="secondary"
            type="button"
            onClick={() => onOpenChange(false)}
          >
            <FormattedMessage defaultMessage="Cancel" />
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
export { HiringGoalModal };
